import { useDispatch, useSelector } from "react-redux";
import {
  setCompanyQuestions,
  setIsInputChecked,
} from "../../redux/globalFunctions";
import { CompanyDataQuestions } from "../companyDataQuestions/CompanyDataQuestions";
import { useEffect } from "react";
import { resetForm, updateCompanyField } from "../../redux/companyForm";
import translations from "../../en.json";
import translationsNo from "../../no.json";

export function CompanyData() {
  const dispatch = useDispatch();
  const { areCompanyQuestionsShown, companyQuestions, language } = useSelector(
    (state) => state.global
  );

  useEffect(() => {
    if (companyQuestions !== null && areCompanyQuestionsShown !== true) {
      dispatch(setIsInputChecked(true));
    }
  }, [companyQuestions]);

  const pageText =
    language === "en" ? translations.companyData : translationsNo.companyData;

  function handleYesClick() {
    dispatch(setIsInputChecked(true));
    dispatch(setCompanyQuestions(true));
    dispatch(resetForm());
  }

  const dummyData = "Your Company";

  function handleNoClick() {
    dispatch(setIsInputChecked(true));
    dispatch(setCompanyQuestions(false));
    dispatch(resetForm());
    dispatch(updateCompanyField(dummyData));
  }

  return (
    <div className="question">
      {areCompanyQuestionsShown ? (
        <CompanyDataQuestions />
      ) : (
        <>
          <p>{pageText.question}</p>
          <div className="radio-group">
            <div className="options">
              <input
                type="radio"
                name="companyData"
                value="yes"
                id="TCdata"
                checked={companyQuestions === true}
                onChange={handleYesClick}
              />
              <label className="radio-label" id="short-label" htmlFor="TCdata">
                {pageText.buttons.yes}
              </label>
            </div>
            <div className="options">
              <input
                type="radio"
                name="companyData"
                value="no"
                id="NTCdata"
                checked={companyQuestions === false}
                onChange={handleNoClick}
              />
              <label className="radio-label" id="short-label" htmlFor="NTCdata">
                {pageText.buttons.no}
              </label>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
